module.exports = {
    digitalPayCreditCardNetworks: {
        visa: 'VISA',
        mastercard: 'MASTERCARD',
        americanexpress: 'AMEX',
        diners: 'DINERS',
        jcb: 'JCB',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/digitalpay-creditcard-networks.js